import { render } from "./ConfirmDlg.vue?vue&type=template&id=4aa35cb1"
import script from "./ConfirmDlg.vue?vue&type=script&lang=js"
export * from "./ConfirmDlg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__